const NUMERIC_INPUT_SELECTOR = 'input[type="number"].form__input, input.js-input-number.form__input';

function sanitizeNumericValue(value, allowDecimal) {
  let sanitized = String(value || '');

  if (allowDecimal) {
    sanitized = sanitized.replace(/[^0-9.,]/g, '');

    const parts = sanitized.split(/[.,]/);
    if (parts.length > 2) {
      sanitized = `${parts.shift()}${parts.length ? '.' : ''}${parts.join('')}`;
    }

    sanitized = sanitized.replace(',', '.');
    return sanitized;
  }

  return sanitized.replace(/\D/g, '');
}

function isNumberOrDecimal(e) {
  const charCode = e.which ? e.which : e.keyCode;

  if (
    charCode < 32 ||
    (charCode >= 48 && charCode <= 57) ||
    charCode === 127
  ) {
    return true;
  }

  if (charCode === 46 || charCode === 44) {
    if (this.value.indexOf('.') >= 0 || this.value.indexOf(',') >= 0) {
      return false;
    }

    return true;
  }

  return false;
}

function bindNumericInput(input) {
  if (input.dataset.inputNumberBound === '1') {
    return;
  }

  input.dataset.inputNumberBound = '1';

  const allowDecimal = input.type === 'number'
    || input.dataset.allowDecimal === '1'
    || input.classList.contains('js-input-number-decimal');

  const applySanitizedValue = () => {
    const sanitized = sanitizeNumericValue(input.value, allowDecimal);
    if (input.value !== sanitized) {
      input.value = sanitized;
    }
  };

  input.addEventListener('keydown', function (e) {
    if (allowDecimal) {
      return isNumberOrDecimal.call(this, e);
    }

    if (e.ctrlKey || e.metaKey || e.altKey) {
      return;
    }

    const charCode = e.which ? e.which : e.keyCode;
    const isControlKey = charCode < 32 || charCode === 127;

    if (isControlKey || (charCode >= 48 && charCode <= 57)) {
      return;
    }

    e.preventDefault();
  });

  input.addEventListener('input', applySanitizedValue);
  input.addEventListener('paste', (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData?.getData('text') || '').trim();
    input.value = sanitizeNumericValue(
      `${input.value}${pasted}`,
      allowDecimal,
    );
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  applySanitizedValue();
}

function initInputNumber() {
  document.querySelectorAll(NUMERIC_INPUT_SELECTOR)?.forEach(bindNumericInput);
}

export { initInputNumber }